import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import Footer from '../components/layout/Footer';
import { contentService } from '../services/api';
import { Container, Section, Spinner } from '../components/ui';
import Seo from '../components/Seo';

const Article = styled.article`
  max-width: 860px;
  margin: 0 auto;
  h1 { font-size: clamp(2rem, 5vw, 3rem); margin-bottom: 2rem; }
  .content { line-height: 1.8; color: ${({ theme }) => theme.colors.neutral[800]}; }
  .content p, .content ul, .content ol, .content h2, .content h3 { margin: 1rem 0; }
  .content h2, .content h3 { color: ${({ theme }) => theme.colors.foreground}; }
  a { color: ${({ theme }) => theme.colors.primary}; }
`;
const State = styled.div`min-height: 360px; display: grid; place-items: center;`;

const PrivacyPage: React.FC = () => {
  const [page, setPage] = useState<any>(null);
  useEffect(() => {
    contentService.getByKey('page:privacy-policy').then(setPage);
  }, []);
  return <div><Seo title="Política de Privacidade" description="Consulte nossa política de privacidade e saiba como tratamos seus dados pessoais." canonicalPath="/politica-de-privacidade" /><Header /><Section><Container>{page ? <Article><h1>{page.title}</h1><div className="content" dangerouslySetInnerHTML={{ __html: page.content }} /></Article> : <State><Spinner $size={34} /></State>}</Container></Section><Footer /></div>;
};

export default PrivacyPage;
